import { Injectable, isDevMode } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  info(...data: any[]): void {
    if (isDevMode()) {
      console.log(data);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error(...data: any[]): void {
    if (isDevMode()) {
      console.error(data);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  warn(...data: any[]): void {
    if (isDevMode()) {
      console.warn(data);
    }
  }
}
